module.exports = __webpack_public_path__ + "static/assets/58be87f32a3153762939878341ba330b.png";